"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("@mui/material"),t=require("@mui/material/styles"),s=require("./assets/icons/Arrow.js"),i=require("./assets/icons/Employees.js");require("react/jsx-runtime");const l=t.styled(o.Button,{shouldForwardProp:e=>e!=="isOpen"})(({theme:e,isOpen:r,fullWidth:n})=>`
    flex-shrink: 0;
    width: auto;

    @media print {
      display: none;
    }

    background-color: ${r?e.palette.primary[50]:"inherit"};
    width: ${n?"100%":"initial"};
  `),a=t.styled(o.Button)(({theme:e})=>`
    && {
      color: ${e.palette.common.black};
    }
  `),c=t.styled(i)(()=>""),d=t.styled(s,{shouldForwardProp:e=>e!=="isOpen"})(({isOpen:e})=>`
    transform: ${e?"rotate(180deg)":"none"};
  `),p=t.styled(o.Menu,{shouldForwardProp:e=>e!=="width"&&e!=="maxHeight"})(({width:e,maxHeight:r})=>`
    & .${o.paperClasses.root} {
      max-height: ${r}px;
      width: ${e}px;
    }

    & .${o.menuItemClasses.root} {
      & .${o.avatarClasses.root} + span {
        max-width: 102px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  `),u=t.styled(o.Divider)(({theme:e})=>({margin:0,backgroundColor:e.palette.grey[300]})),m=t.styled(o.Typography)`
  margin-left: 8px;
  display: inline;
`;exports.ArrowIcon=d;exports.DropdownButton=l;exports.DropdownText=a;exports.EmployeesIcon=c;exports.RoleCount=m;exports.SearchDivider=u;exports.SearchMenu=p;
